import { Link } from "react-router-dom";
import { CONTACT, IMG, NAV } from "../data/site";

export const Footer = () => {
  return (
    <footer className="grain relative overflow-hidden bg-graphite text-warmwhite" data-testid="site-footer">
      {/* Footer grid */}
      <div className="u-container relative z-10 grid grid-cols-2 gap-10 pb-16 pt-20 md:grid-cols-12">
        <div className="col-span-2 md:col-span-5">
          <Link to="/" aria-label="Casagon start" className="inline-flex items-center">
            <img
              src={IMG.casagonLogo}
              alt="Casagon Bygg & Allservice AB"
              className="h-11 w-auto md:h-12"
            />
          </Link>
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-warmwhite/60">
            Specialist på golvläggning med bred kompetens inom bygg och renovering. Etablerade sedan
            2015 – med uppdrag i hela Skåne och hela Göteborg.
          </p>
        </div>

        <div className="col-span-2 md:col-span-3 md:col-start-7">
          <p className="overline text-warmwhite/40">Sidor</p>
          <ul className="mt-5 space-y-3">
            {NAV.filter((n) => n.to !== "/").map((n) => (
              <li key={n.to}>
                <Link
                  to={n.to}
                  data-testid={`footer-link-${n.label.toLowerCase().replace(/[^a-z]/g, "")}`}
                  className="link-underline text-sm text-warmwhite/80 hover:text-warmwhite"
                >
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-span-2 md:col-span-3">
          <p className="overline text-warmwhite/40">Kontakt</p>
          <ul className="mt-5 space-y-3 text-sm text-warmwhite/80">
            <li>
              <a href={CONTACT.phoneHref} data-testid="footer-phone" className="link-underline">
                {CONTACT.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="link-underline break-all">
                {CONTACT.email}
              </a>
            </li>
            <li className="text-warmwhite/60">Utgår från {CONTACT.city}</li>
            <li className="text-warmwhite/60">{CONTACT.serviceArea}</li>
          </ul>
        </div>
      </div>

      <div className="u-container relative z-10 flex flex-col justify-between gap-3 border-t border-warmwhite/10 py-8 text-xs text-warmwhite/45 md:flex-row">
        <span>© {new Date().getFullYear()} Casagon Bygg & Allservice AB</span>
        <span>
          Hemsida skapad av{" "}
          <a
            href="https://elido.nu/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-elido"
            className="link-underline text-warmwhite/80 hover:text-wood"
          >
            Elido
          </a>
        </span>
      </div>
    </footer>
  );
};
